import "./style.scss";
import { Select, Spin } from "antd";
import * as React from "react";

const Option = Select.Option;

interface SearchSelectProps {
  objects: any[];
  idKey: any;
  valueKey: any;
  selectedObject: any;
  handleSelection: (id: any) => void;
  size?: "small" | "default" | "large";
  placeholder?: string;
  fetching?: boolean;
}

export const SearchSelect = (props: SearchSelectProps) => {
  const renderOptions = () => {
    return props.objects.map((object: any) => (
      <Option key={object[props.idKey]}>{object[props.valueKey]}</Option>
    ));
  };

  return (
    <div className="search-select">
      <Select
        showSearch
        placeholder={props.placeholder}
        notFoundContent={props.fetching ? <Spin size="small" /> : "Not Found"}
        optionFilterProp="children"
        size={props.size || "default"}
        style={{ width: "100%" }}
        value={
          props.selectedObject
            ? props.selectedObject[props.valueKey]
            : undefined
        }
        onSelect={(value: any, option: any) => props.handleSelection(value)}
      >
        {renderOptions()}
      </Select>
    </div>
  );
};



// WEBPACK FOOTER //
// ./client/modules/AnalyticsMetric/components/Dropdown/SearchSelect/index.tsx